
import { useUserClasses } from "./useUserClasses";
import { useSubscriptionMutations } from "./useSubscriptionMutations";
import { useProfile } from "./useProfile";

export const useClassSubscriptions = () => {
  const { profile } = useProfile();
  const { data: myClasses, isLoading: loadingMyClasses } = useUserClasses();
  const { subscribeMutation, unsubscribeMutation } = useSubscriptionMutations();

  // Re-export with proper dependency on profile changes
  return {
    myClasses,
    loadingMyClasses,
    subscribeMutation,
    unsubscribeMutation,
    profile, // Include profile to trigger re-renders when gym changes
  };
};
